<template>
  <el-container class="my_parent_box">
    <el-header class="my_head_box" height="71px">
      <myHeader />
    </el-header>
    <el-main>
      <router-view />
      <!-- 登录对话框 -->
      <loginDialog :show="loginVisible"></loginDialog>
      <!-- 注册对话框 -->
      <registerDialog :show="registerVisible"></registerDialog>
      <!-- 侧边栏 -->
      <scroll_online></scroll_online>
    </el-main>
    <el-footer height="228px">
      <myFooter />
    </el-footer>
  </el-container>
</template>

<script>
import myHeader from "./components/myHeader.vue";
import myFooter from "@/components/myFooter.vue";
import loginDialog from "@/components/login/login.vue";
import registerDialog from "@/components/login/register.vue";
import scroll_online from "@/components/scroll_online.vue";
export default {
  components: {
    myHeader,
    myFooter,
    loginDialog,
    registerDialog,
    scroll_online
  },
  computed: {
    loginVisible() {
      return this.$store.state.isLoginDialog;
    },
    registerVisible() {
      return this.$store.state.isRegisterDialog;
    }
  }
};
</script>

<style lang="scss" scoped>
.my_parent_box {
  min-height: 100vh;
  .my_head_box {
    border-bottom: 1px solid #eee;
  }
}
</style>